import React from 'react';

import { Tag, Typography } from 'antd';

import { fieldIsBlock, FieldsActionBR, FieldsNameBR } from '../../constants';
import type { ChangeLogHistoryItemValue } from '../../constants';
import formatHistoryInfo from '../formatters';

type HistoryDetailsItems = {
  field: string;
  change: ChangeLogHistoryItemValue;
};

function HistoryDetailsItems({ field, change }: HistoryDetailsItems) {
  const fieldHasBooleanValue = typeof field === 'boolean';
  const haveOnlyTo = change.action === 'add';
  const showFrom = !fieldHasBooleanValue || !haveOnlyTo;
  const showTo = !fieldHasBooleanValue;

  return (
    <div className='w-full'>
      <div className='flex flex-col [&_p]:p-1 [&:not(:last-child)]:pb-6'>
        <div className='grow'>
          <Typography.Text>{FieldsNameBR[field as keyof typeof FieldsNameBR]}</Typography.Text>
        </div>
        <div
          className='flex data-[block=true]:flex-col max-sm:flex-col [&>div]:flex [&>div]:items-center'
          data-block={fieldIsBlock.includes(field)}
          key={field}
        >
          <div>
            <Tag color='warning'>{FieldsActionBR[change.action]}</Tag>
          </div>
          {change?.status && (
            <div>
              <Typography.Text>{change.status}</Typography.Text>
            </div>
          )}
          {showFrom && (
            <div>
              <Typography.Text delete type='secondary' className='[line-break:anywhere] [&_img]:opacity-50'>
                {formatHistoryInfo(field, change.from)}
              </Typography.Text>
            </div>
          )}
          {showTo && (
            <div>
              <Typography.Text className='[line-break:anywhere]'>{formatHistoryInfo(field, change.to)}</Typography.Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HistoryDetailsItems;
